export default __webpack_public_path__ + "static/media/NotoSansKR-Regular.957d49ad.woff";